import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Tag } from '@coolblue-development/freddy';
export const OptionalTag = ({ freddyTag: { intent, variant, content } }) => {
    return (_jsx(Box, { children: _jsx(Tag, { intent: intent, variant: variant, children: content }) }));
};
//# sourceMappingURL=OptionalTag.js.map